export default __webpack_public_path__ + "static/media/calendar-blue.40ea667c.svg";